module.exports = __webpack_public_path__ + "static/gallery2-3fe9ee0a4dcf6d67f6f114fe8fd36920.png";